{
	"localeMapping": {
		"de-DE": "de_DE",
		"en-AU": "en_US",
		"en-CA": "en_US",
		"en-GB": "en_US",
		"en-IN": "en_US",
		"en-US": "en_US",
		"es-419": "es_ES",
		"es-AR": "es_ES",
		"es-ES": "es_ES",
		"fr-FR": "fr_FR",
		"it-IT": "it_IT",
		"ja-JP": "ja_JP",
		"pt-BR": "pt_BR",
		"th-TH": "th_TH",
		"id-ID": "id_ID",
		"tr-TR": "tr_TR",
		"ru-RU": "ru_RU",
		"hi-IN": "hi_IN"
	},
	"legalHelpUrls": {
		"FR": "/fr_FR/legal/mentions-légales"
	},
	"legalUrls": {
		"DE": "/l/de/p/impressum",
		"AT": "/l/de/p/impressum",
		"CH": "/l/de/p/impressum",
		"LI": "/l/de/p/impressum",
		"LU": "/l/de/p/impressum"
	},
	"accessibilityStatementUrls": {
		"en_US": "legal/accessibility-statement",
		"fr_FR": "legal/accessibility-statement",
		"de_DE": "legal/accessibility-statement",
		"it_IT": "aspetti-legali/accessibility-statement",
		"ja_JP": "legal/accessibility-statement",
		"ru_RU": "legal/accessibility-statement",
		"es_ES": "legal/accessibility-statement",
		"pt_BR": "legal/accessibility-statement",
		"tr_TR": "legal/accessibility-statement",
		"th_TH": "legal/accessibility-statement",
		"hi_IN": "legal/accessibility-statement",
		"id_ID": "legal/accessibility-statement"
	}
}
